import {Bubbles} from '@management-ui/core';
import {withTheme} from '@mui/styles';
import React from 'react';
import withOrderStatuses from './withOrderStatuses';

const OrderStatus = ({order, statuses}) => (
  <Bubbles bubbles={statuses.filter(({key}) => key === order.status).map(({title, colour}) => (
    {
      id: 0,
      label: title,
      colour: colour
    }
  ))}/>
);

export default withOrderStatuses(withTheme(OrderStatus));
